import script from "./DeleteProjectMemberModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteProjectMemberModal.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteProjectMemberModal.vue?vue&type=style&index=0&id=41f581ed&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f581ed"]])

export default __exports__